// multi-select filter types
export interface MultiSelectFilter {
  sites: string[];
  turbineModels: string[];
  componentsMajor: string[];
  componentsMinor: string[];
  outcomeName: string[];
  failureModes: string[];
  excludedCaseIds: string[];
  majorCorrective: string[];
  plannedReactive: string[];
}

export interface NumericRangeFilter {
  operationTimeMin?: number;
  operationTimeMax?: number;
}

export interface DateRangeFilter {
  dateFrom?: string;
  dateTo?: string;
}

// Failure filtering
export interface FailureFilters
  extends Partial<MultiSelectFilter>,
  NumericRangeFilter,
  DateRangeFilter {
  page?: number;
  size?: number;
}

// Default empty filter state
export const DEFAULT_FAILURE_FILTERS: FailureFilters = {
  sites: [],
  turbineModels: [],
  componentsMajor: [],
  componentsMinor: [],
  outcomeName: [],
  failureModes: [],
  excludedCaseIds: [],
  majorCorrective: [],
  plannedReactive: [],
  page: 1,
  size: 20,
};

// Filter tag for visual display
export interface FilterTag {
  id: string;
  category: keyof typeof FILTER_CATEGORIES | 'time' | 'date';
  label: string;
  value: string | number;
  color: string;
}

// Filter category configuration
export interface FilterCategory {
  key: keyof MultiSelectFilter;
  label: string;
  color: string;
  description: string;
}

export const FILTER_CATEGORIES: Record<string, FilterCategory> = {
  sites: {
    key: 'sites',
    label: 'Sites',
    color: 'bg-blue-100 text-blue-800 border-blue-200',
    description: 'Wind farm locations',
  },
  turbineModels: {
    key: 'turbineModels',
    label: 'Turbine Models',
    color: 'bg-green-100 text-green-800 border-green-200',
    description: 'Turbine manufacturers and models',
  },
  componentsMajor: {
    key: 'componentsMajor',
    label: 'Components',
    color: 'bg-purple-100 text-purple-800 border-purple-200',
    description: 'Major component categories',
  },
  componentsMinor: {
    key: 'componentsMinor',
    label: 'Sub-components',
    color: 'bg-orange-100 text-orange-800 border-orange-200',
    description: 'Specific component parts',
  },
  failureTypes: {
    key: 'outcomeName',
    label: 'Failure Types',
    color: 'bg-red-100 text-red-800 border-red-200',
    description: 'Repair, replacement, or planned actions',
  },
  failureModes: {
    key: 'failureModes',
    label: 'Failure Modes',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    description: 'Specific failure mechanisms',
  },
  majorCorrective: {
    key: 'majorCorrective',
    label: 'Major Corrective',
    color: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    description: 'Marked as Major Correctives'
  },
  plannedReactive: {
    key: 'plannedReactive',
    label: 'Planned / Reactive',
    color: 'bg-pink-100 text-pink-800 border-pink-200',
    description: 'Planned or Reactive'
  },
  excludedCases: {
    key: 'excludedCaseIds',
    label: 'Excluded Cases',
    color: 'bg-gray-100 text-gray-800 border-gray-200',
    description: 'Cases excluded from analysis',
  },
};
